import { handleActions } from 'redux-actions';
import { AuditLogsState } from './interfaces';
import Types from './types';

const initialState: AuditLogsState = {
  auditLogsData: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  isLoading: false,
};

export default handleActions(
  {
    [Types.GET_AUDIT_LOGS_REQUEST]: (state: AuditLogsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_AUDIT_LOGS_FULFILLED]: (state: AuditLogsState, { payload }) => ({
      ...state,
      isLoading: false,
      auditLogsData: payload,
    }),
    [Types.GET_AUDIT_LOGS_REJECTED]: (state: AuditLogsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.GET_CONTEXT_AUDIT_LOGS_REQUEST]: (state: AuditLogsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_CONTEXT_AUDIT_LOGS_FULFILLED]: (
      state: AuditLogsState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      auditLogsData: payload,
    }),
    [Types.GET_CONTEXT_AUDIT_LOGS_REJECTED]: (state: AuditLogsState) => ({
      ...state,
      isLoading: false,
    }),
  },
  initialState
);
